$(document).on("click","li.tab-link",function(e) {
e.preventDefault();
 // alert(7)
   $(".li.tab-link").addClass("current");  
var var_url = $(this).find('a.tab-link').attr("href");
 // alert(var_url);
var pro_url = $(this).attr('data-pro-url');
var pro_var_html=$(this).html();
console.log(pro_var_html);
$.ajax({
url:var_url,
type:'GET',
success: function(data){
console.log(data);
$('.main-blog').html($(data).find('.main-blog').html());
var blog_html = $('.main-blog').html();
console.log(blog_html)
}
});
});




$(document).on('click', '.delete-address-btn', function() {
    var addressId = $(this).attr('delete-address-id');
    var url = '/account/addresses/' + addressId + '.js';
  var confirmDelete = confirm("Are you sure you wish to delete this address?");
    if (!confirmDelete) {
        return;
    } 
  location.reload();
    $.ajax({
        url: url,
        type: 'DELETE',
        dataType: 'json',
        success: function(response) {
        },
        error: function(xhr, status, error) {            
            console.error('Error deleting address:', error);
        }
    });
});

 $(document).on('click', '.address-cancel-bttn', function() {
    if ($('button.address-edit-button').attr('aria-expanded') == 'true') {
      $('button.address-edit-button').attr('aria-expanded', 'false');
       // $('body').removeClass('cust-edit-form');
      $('.customer-edit-form').css('display','none');
    } else {
      $('button.address-edit-button').attr('aria-expanded', 'false');
       $('.customer-edit-form').css('display','none');
         $('body').removeClass('cust-edit-form');
       $('.customer-edit-form').removeClass('new-edit-form');
    }

     if ($('button.address-edit1-button').attr('aria-expanded') == 'true') {
      $('button.address-edit1-button').attr('aria-expanded', 'false');
    } else {
      $('button.address-edit1-button').attr('aria-expanded', 'false');
    }
   
  });

  $(document).on('click', 'button.address-edit-button', function() {
    var daraAttr = $(this).attr('aria-expanded');
    var formdata = $(this).attr('aria-controls');    
      $('.customer-edit-form').addClass('new-edit-form');
    $('body').addClass('cust-edit-form');
      $('#'+formdata).show();
  });

	  $(document).mouseup(function (e) {
     var popup = $(".customer-edit-form");
     if (!$('button.address-edit-button').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {       
       popup.hide();
        $('body').removeClass('cust-edit-form');
     $('.customer-edit-form').removeClass('new-edit-form');
     }
 });




  $(document).on('click', 'button.address-edit1-button', function() {
    if ($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', 'true');
    } else {
      $(this).attr('aria-expanded', 'false');
    }
  });


  $(document).on('click', '.address-edit1-button', function() {
    $('div#AddAddress').css('display','block');
  });

 $(document).on('click', '.address-cancel-bttn', function() {
      $('div#AddAddress').css('display','none');
 });